import { api, notify } from "assets/scripts/utilities/api-clients";

export const index = async (options = {}) => {
  const response = await api.get("kam/brands", options);

  return response;
};

export const post = async (brand) => {
  const response = await api.post("kam/brands", brand);

  return response;
};

export const put = async (brand) => {
  const response = await api.put("kam/brands", brand);

  notify({
    message: "Brand updated successfully",
    type: "positive",
  });

  return response;
};
